<!-- Revised on 2024/12/11 by mnavarro -->
<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex gap-2">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2 gap-2 d-flex flex-wrap">
                    <!-- Edit actions (Add, clone and edit) -->
                    
                    <!-- Activate and deactivate actions -->
                    
                    <!-- Recover and delete actions -->
                    
                    <!-- Interactions with database (filters and reload) -->
                    <OrderBackOutboxQueueActionFilter id="orderBackOutboxQueueActionFilter" :filter-action-selected="listFilters?.action" @orderback-outbox-queue-action-filter-change="orderbackOutboxQueueActionFilterChange"/>
                    <OrderBackOutboxQueueStatusFilter id="orderBackOutboxQueueStatusFilter" :filter-status-selected="listFilters?.status" @orderback-outbox-queue-status-filter-change="orderbackOutboxQueueStatusFilterChange"/>
                    <ClearAllFiltersButton id="clearAllFiltersButton" :enable-clear-all-filters="checkActiveFilters()" @clear-all-filters="clearAllFilters"/>
                    <ReloadButton id="reload" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Search space -->
                    <Searchbox id="searchbox" :enable-search="enableSearch" :filter-search="listFilters?.search" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ClearAllFiltersButton from "./../../../../../generic_components/ClearAllFiltersButton.vue";
    import OrderBackOutboxQueueActionFilter from "./../filters/OrderBackOutboxQueueActionFilter.vue";
    import OrderBackOutboxQueueStatusFilter from "./../filters/OrderBackOutboxQueueStatusFilter.vue";
    import ReloadButton from "./../../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../../generic_components/Searchbox.vue";

    export default {
        name: "OrderBackOutboxQueueListTableHeader",
        components: {
            ClearAllFiltersButton,
            OrderBackOutboxQueueActionFilter,
            OrderBackOutboxQueueStatusFilter,
            ReloadButton,
            Searchbox
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['clear-all-filters', 'orderback-outbox-queue-action-filter-change', 
                'orderback-outbox-queue-status-filter-change', 'search-change', 'reload-page'],
        methods: {
            checkActiveFilters() {
                return this.listFilters?.action !== '' || 
                       this.listFilters?.search !== '' ||
                       this.listFilters?.status !== '';
            },
            clearAllFilters() {
                this.$emit("clear-all-filters");
            },
            orderbackOutboxQueueActionFilterChange(action) {
                this.$emit("orderback-outbox-queue-action-filter-change", action);
            },
            orderbackOutboxQueueStatusFilterChange(status) {
                this.$emit("orderback-outbox-queue-status-filter-change", status);
            },
            reloadPage() {
                this.$emit("reload-page");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            }
        }
    }

</script>